"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("dayjs/locale/vi");
// 越南语
var Calendar = {
    formatYear: 'YYYY',
    formatMonth: 'MMMM YYYY',
    monthBeforeYear: true,
    today: 'Hôm nay',
    view: {
        month: 'Tháng',
        year: 'Năm',
        week: 'Tuần',
        day: 'Ngày',
    },
    month: {
        long: {
            January: 'Tháng Một (Giêng)',
            February: 'Tháng Hai',
            March: 'Tháng Ba',
            April: 'Tháng Tư',
            May: 'Tháng Năm',
            June: 'Tháng Sáu',
            July: 'Tháng Bảy',
            August: 'Tháng Tám',
            September: 'Tháng Chín',
            October: 'Tháng Mười',
            November: 'Tháng Mười Một',
            December: 'Tháng Mười Hai',
        },
        short: {
            January: 'Thg1',
            February: 'Thg2',
            March: 'Thg3',
            April: 'Thg4',
            May: 'Thg5',
            June: 'Thg6',
            July: 'Thg7',
            August: 'Thg8',
            September: 'Thg9',
            October: 'Thg10',
            November: 'Thg11',
            December: 'Thg12',
        },
    },
    week: {
        long: {
            self: 'Tuần',
            monday: 'Thứ Hai',
            tuesday: 'Thứ Ba',
            wednesday: 'Thứ Tư',
            thursday: 'Thứ Năm',
            friday: 'Thứ Sáu',
            saturday: 'Thứ Bảy',
            sunday: 'Chủ Nhật',
        },
        short: {
            self: 'Tuần',
            monday: 'T2',
            tuesday: 'T3',
            wednesday: 'Tư',
            thursday: 'Năm',
            friday: 'Sáu',
            saturday: 'Bảy',
            sunday: 'CN',
        },
    },
};
exports.default = {
    locale: 'vi-VN',
    dayjsLocale: 'vi',
    Calendar: Calendar,
    DatePicker: {
        Calendar: Calendar,
        placeholder: {
            date: 'Vui lòng chọn một ngày',
            week: 'Vui lòng chọn một tuần',
            month: 'Vui lòng chọn một tháng',
            year: 'Vui lòng chọn một năm',
            quarter: 'Vui lòng chọn một phần tư',
        },
        placeholders: {
            date: ['ngày bắt đầu', 'ngày kết thúc'],
            week: ['đầu tuần', 'cuối tuần'],
            month: ['đầu tháng', 'cuối tháng'],
            year: ['năm bắt đầu', 'năm kết thúc'],
            quarter: ['quý đầu', 'quý kết thúc'],
        },
        selectTime: 'Vui lòng chọn thời gian',
        selectDate: 'Vui lòng chọn một ngày',
        today: 'Hôm nay',
        now: 'Hiện nay',
        ok: 'Đảm bảo',
    },
    Drawer: {
        okText: 'Đảm bảo',
        cancelText: 'Hủy bỏ',
    },
    Empty: {
        noData: 'Không có dữ liệu',
    },
    Modal: {
        okText: 'Đảm bảo',
        cancelText: 'Hủy bỏ',
    },
    Pagination: {
        goto: 'Di đến',
        page: 'Trang',
        countPerPage: '/Trang',
        total: '{0} trong tổng số',
        prev: 'Trang trước',
        next: 'Trang tiếp theo',
        currentPage: 'Trang {0}',
        prevSomePages: 'Chuyển tiếp {0} trang',
        nextSomePages: 'Quay lại {0} trang',
        pageSize: 'Số trang',
    },
    Popconfirm: {
        okText: 'Đảm bảo',
        cancelText: 'Hủy bỏ',
    },
    Table: {
        okText: 'Đảm bảo',
        resetText: 'Cài lại',
        sortAscend: 'Nhấp để sắp xếp theo thứ tự tăng dần',
        sortDescend: 'Bấm để sắp xếp theo thứ tự giảm dần',
        cancelSort: 'Bấm để bỏ sắp xếp',
    },
    TimePicker: {
        ok: 'Đảm bảo',
        placeholder: 'Hãy chọn một thời điểm',
        placeholders: ['Thời gian bắt đầu', 'Thời gian kết thúc'],
        now: 'Hiện nay',
    },
    Progress: {
        success: 'Sự thành công',
        error: 'Thất bại',
    },
    Upload: {
        start: 'Khởi đầu',
        cancel: 'Hủy bỏ',
        delete: 'Xóa bỏ',
        reupload: 'Nhấp để thử lại',
        upload: 'Nhấp để tải lên',
        preview: 'Xem trước',
        drag: 'Nhấp hoặc kéo tệp để tải lên đây',
        dragHover: 'Giải phóng tệp và bắt đầu tải lên',
        error: 'Tải lên không thành công',
    },
    Typography: {
        copy: 'Sao chép',
        copied: 'Đã sao chép',
        edit: 'Biên tập',
        fold: 'Nếp gấp',
        unfold: 'Mở rộng',
    },
    Transfer: {
        resetText: 'Cài lại',
    },
    ImagePreview: {
        fullScreen: 'Toàn màn hình',
        rotateRight: 'Xoay phải',
        rotateLeft: 'Xoay sang trái',
        zoomIn: 'Phóng to',
        zoomOut: 'Thu nhỏ',
        originalSize: 'Kích thước ban đầu',
    },
};
